enum Sort {
  proximity = "proximity",
  values = "values",
  connection = "connection",
}

export { Sort };
